/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import { Button, makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
	container: {
		maxHeight: 30,
		display: "flex",
		gap: 10,
	},
	cancelBtn: {
		opacity: (props) => (props.disableCancel ? 0.4 : 1),
	},
	saveBtn: {
		opacity: (props) => (props.disableSave ? 0.4 : 1),
		backgroundColor: "#cc1f20",
		color: "#fff",
		borderColor: "#cc1f20",
		"&:hover": {
			backgroundColor: "#cc1f20",
		},
		"&:focus": {
			backgroundColor: "#cc1f20",
		},
		"&:disabled": {
			backgroundColor: "#cc1f20",
			color: "#fff",
		},
	},
	removeBtn: {
		opacity: (props) => (props.disableRemove ? 0.4 : 1),
		color: "#cc1f20",
		borderColor: "#cc1f20",
	},
});

const ActionButtons = ({
	showSave,
	showRemove,
	showCancel,
	onSave,
	onRemove,
	onCancel,
	disableSave,
	disableRemove,
	disableCancel,
	cancelBtnClass = "",
	removeBtnClass = "",
	saveBtnClass = "",
	className = "",
	saveLabel = "Save",
	cancelLabel = "Cancel",
	removeLabel = "Remove",
}) => {
	const classes = useStyles({ disableCancel, disableRemove, disableSave });

	return (
		<div className={`${classes.container} ${className}`}>
			{showCancel && (
				<Button
					disabled={disableCancel}
					variant="outlined"
					size="small"
					onClick={onCancel}
					className={`${classes.cancelBtn} ${cancelBtnClass}`}
					data-test-id="action-cancel-btn"
				>
					{cancelLabel}
				</Button>
			)}
			{showRemove && (
				<Button
					variant="outlined"
					size="small"
					disabled={disableRemove}
					className={`${classes.removeBtn} ${removeBtnClass}`}
					onClick={onRemove}
					data-test-id="action-remove-btn"
				>
					{removeLabel}
				</Button>
			)}
			{showSave && (
				<Button
					variant="contained"
					disabled={disableSave}
					size="small"
					className={`${classes.saveBtn} ${saveBtnClass}`}
					onClick={onSave}
					data-test-id="action-save-btn"
				>
					{saveLabel}
				</Button>
			)}
		</div>
	);
};

export default ActionButtons;
